
import cookie from './lib/cookie'

const TOKEN_NAME = 'token'
const domainString = location.hostname.split('.')
const ROOT_DOMAIN_NAME = [domainString[domainString.length - 2], domainString[domainString.length - 1]].join('.')

// const ROOT_DOMAIN_NAME = 'shijqq.com'

let auth = {
  userId: null,
  onUserIdChange: null,
  getToken () {
    var result = null
    var str = cookie.getCookieUtil(TOKEN_NAME)
    if (str) {
      try {
        var val = JSON.parse(str)
        if (val.token) {
          if (new Date().getTime() < val.expires) {
            result = val.token
          } else {
            // 刷新 token  ，更新 token cookie 返回
            var xhr = new XMLHttpRequest()
            xhr.open('get', '/api/refresh_token', false)
            xhr.setRequestHeader('token', val.token)
            xhr.send()
            if (xhr.status === 200) {
              var obj = JSON.parse(xhr.responseText)
              if (obj.access_token) {
                this.setToken(obj.access_token, val.remember)
                result = obj.access_token
              }
            } else {
              console.error('交换 token 失败')
            }
          }
        }
      } catch (err) {
        console.error('解析 token 失败')
      }
    } else {
      console.error('用户没有登录')
    }
    return result || ''
  },
  setToken (token, remember) {
    if (token) {
      let now = new Date()
      let val = {
        token,
        remember,
        expires: new Date().getTime() + 7 * 24 * 60 * 60 * 1000
      }
      let expires
      if (remember) {
        expires = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
      } else {
        expires = new Date(now.getTime() + 2 * 60 * 60 * 1000)
      }
      cookie.setCookieUtil(TOKEN_NAME, JSON.stringify(val), expires, ROOT_DOMAIN_NAME)
    }
  },
  clearToken () {
    cookie.delCookieUtil(TOKEN_NAME, ROOT_DOMAIN_NAME)
  },
  isRemeber () {
    let result = false
    let str = cookie.getCookieUtil(TOKEN_NAME)
    if (str) {
      try {
        let val = JSON.parse(str)
        if (val.remember) {
          result = true
        }
      } catch (err) {

      }
    }
    return result
  },
  isLogin () {
    let token = this.getToken()
    if (!token) return false
    var xhr = new XMLHttpRequest()
    xhr.open('get', '/api/current_user', false)
    xhr.setRequestHeader('token', token)
    xhr.send()
    if (xhr.status === 200) {
      return true
    } else {
      return false
    }
  },
  getUserId () {
    let token = this.getToken()
    if (!token) return null
    if (!this.userId) {
      var xhr = new XMLHttpRequest()
      xhr.open('get', '/api/current_user', false)
      xhr.setRequestHeader('token', token)
      xhr.send()
      if (xhr.status === 200) {
        this.userId = JSON.parse(xhr.responseText).userId
        return this.userId
      } else {
        return null
      }
    } else {
      return this.userId
    }
  },
  setCurrentUserInfo (obj) {
    window.sessionStorage._current_user_info = JSON.stringify(obj)
  },
  getCurrentUserInfo (obj) {
    if (window.sessionStorage._current_user_info) {
      return JSON.parse(window.sessionStorage._current_user_info)
    } else {
      return null
    }
  },
  clearCurrentUserInfo () {
    delete window.sessionStorage._current_user_info
  },
  errorCodeToString (errorCode, render) {
    let h = render
    switch (errorCode) {
      case 400001 : {
        return '请求的地址不正确'
      }
      case 400002 : {
        return '请求的地址不正确'
      }
      case 400004 : {
        return '更新令牌失败，转入的令牌无效'
      }
      case 401001 : {
        return '需要登录才能使用此功能，请确认'
      }
      case 401002 : {
        return '登录已过期，为保障帐号安全需要您重新登录'
      }
      case 401003 : {
        return h('div', {
          style: {
            paddingLeft: '36px'
          }
        }, [
          h('i', {
            'class': 'el-icon-warning',
            style: {
              fontSize: '24px',
              position: 'absolute',
              marginLeft: '-36px',
              color: '#e6a23c'
            }
          }),
          h('div', {
            style: {
              paddingTop: '3px'
            }
          }, '您的账号刚刚在另一地点登录，您已被迫下线。'),
          h('div', {
            style: {
              paddingTop: '15px'
            }
          }, [
            '如果这不是您本人的操作，那您的密码很可能已经泄露，建议您',
            h('a', {
              style: {
                color: '#66b1ff',
                cursor: 'pointer',
                textDecoration: 'none'
              },
              on: {
                click: () => {
                  window.location.href = `//sso.shijqq.com/#/auth?backUrl=` + encodeURIComponent(window.location.href)
                }
              }
            }, ' 重新登录并重置密码')
          ])
        ])
      }
      case 401004 : {
        return h('div', {
          style: {
            paddingLeft: '36px'
          }
        }, [
          h('i', {
            'class': 'el-icon-warning',
            style: {
              fontSize: '24px',
              position: 'absolute',
              marginLeft: '-36px',
              color: '#e6a23c'
            }
          }),
          h('div', {
            style: {
              paddingTop: '3px'
            }
          }, '登录过期或权限变更，请重新登录。')
        ])
      }
      case 401005 : {
        return '您的帐户被禁用，您已被迫下线'
      }
      case 403001 : {
        return '您没有权限访问此功能'
      }
    }
  }
}

let token = auth.getToken()

setInterval(() => {
  let t = auth.getToken()
  if (t !== token && auth.onUserIdChange && auth.userId !== auth.getUserId()) {
    auth.userId = null
    auth.userId = auth.getUserId()
    token = t
    auth.onUserIdChange(auth.userId)
  }
}, 2000)

export default auth
